/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { sendPopupRoutingAction } from '../../+state/toolbelt.actions';
import { Observable, of, take } from 'rxjs';
import { SystemInfo } from 'libs/sysque/toolbelt/data-access/src/lib/domain/system-info';
import { SysqueElectricalState } from '../../models/sysque-electrical-state';

@Injectable({
  providedIn: 'root',
})
export class SystemOperationsService {
  constructor(private store: Store) {}

  public openDialog(route: string, width: number, height: number): void {
    this.store.dispatch(sendPopupRoutingAction({ route, width: width, height: height }));
  }

  public createSystem(stateSystemInfo: Observable<SystemInfo[]>, dockedState: SysqueElectricalState): void {
    stateSystemInfo = of(dockedState.systemList);
    dockedState.selectedSystem = dockedState.systemList[dockedState.systemList.length - 1].name;
  }

  public renameSystem(
    stateSystemInfo: Observable<SystemInfo[]>, 
    dockedState: SysqueElectricalState, 
    selectedSystemIndex?: number
  ): void {
    if (selectedSystemIndex === undefined || selectedSystemIndex < 0) {
      console.error("Invalid or undefined selectedSystemIndex.");
      return;
    }
    stateSystemInfo = of(dockedState.systemList);
    stateSystemInfo.pipe(take(1)).subscribe((systemsList) => {
      if (!systemsList || systemsList.length === 0) {
        return;
      }
      if (selectedSystemIndex >= systemsList.length) {
        return;
      }
      const selectedSystem = systemsList[selectedSystemIndex];
      const dockedSystem = dockedState.systemList[selectedSystemIndex];
  
      if (dockedState.name !== dockedSystem.name) {
        dockedState.selectedSystem = dockedSystem.name;
      }
    });
  }  
  
  public deleteSystem(
    stateSystemInfo: Observable<SystemInfo[]>, 
    dockedState: SysqueElectricalState, 
    selectedSystemIndex?: number
  ): void {
    let systemsList: SystemInfo[] = [];
    stateSystemInfo.pipe(take(1)).subscribe((response) => {
      systemsList = response;
    });
    stateSystemInfo = of(dockedState.systemList);
    if (selectedSystemIndex !== undefined && selectedSystemIndex >= 0 && selectedSystemIndex < systemsList.length) {
      dockedState.selectedSystem = dockedState.systemList[selectedSystemIndex]?.name || null;
    } else {
      if (systemsList[0].name !== dockedState.systemList[0].name) {
        dockedState.selectedSystem = dockedState.systemList[0].name;
      } else if (
        systemsList[systemsList.length - 1].name !==
        dockedState.systemList[dockedState.systemList.length - 1].name
      ) {
        dockedState.selectedSystem = dockedState.systemList[dockedState.systemList.length - 1].name;
      } else {
        for (let index = 1; index < systemsList.length; index++) {
          if (systemsList[index].name !== dockedState.systemList[index].name) {
            dockedState.selectedSystem = dockedState.systemList[index - 1].name;
            break;
          }
        }
      }
    }
  }
}
